<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="`Perpanjangan Otomatis`" :modal-id="`modal-detail-info`" @close="back">
            <template v-slot:modal-body>
                <div class="p-t-8">
                    <p class="m-d-16">
                        Perpanjangan otomatis dilakukan ketika masa kuota berakhir & ditagih dengan memotong saldo
                        M-Coin.
                    </p>
                    <ul class="p-l-20">
                        <li>
                            Jika kuota pesan habis namun masa aktif belum berakhir, maka dikenakan tarif 100 m-coin per
                            pesan yang dikirim.
                        </li>
                        <li>
                            Apabila saat perpanjangan saldo M-Coin tidak mencukupi, maka Autosender tidak dapat
                            digunakan dan Anda perlu melakukan perpanjangan secara manual.
                        </li>
                    </ul>
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";

export default {
    name: "ModalDetailInfo",
    components: {
        SOSlotModal,
    },
    data() {
        return {
            backLink: "wa_autosender.register.step2",
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.setBackLink(from.name);
        });
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#modal-detail-info`).modal("show");
    },
    methods: {
        async back() {
            await this.$router.push({ name: this.backLink });
        },
        closeModal() {
            $(`#modal-detail-info`).modal("hide");
        },
        setBackLink(val) {
            this.backLink = val;
        },
    },
};
</script>
